import { Toaster } from 'react-hot-toast';
import {
	HashRouter as Router,
	Switch,
	Route,
	Redirect,
	useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import Sidebar from "components/Sidebar";
import Dashboard from "pages/Dashboard";
import User from "pages/User";
import Aspek from "pages/Aspek";
import Rapor from "pages/Rapor";
import BestStaff from "pages/BestStaff";
import Login from "pages/Login";
import Kegiatan from "pages/Kegiatan";
import Footer from "components/Footer";

import { checkUser } from "helpers/Session";

// Tailwind CSS Style Sheet
import "assets/styles/tailwind.css";
import DetailRapor from "pages/DetailRapor";

const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
};

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={(props) =>
			checkUser() ? <Component {...props} /> : <Redirect to="/" />
		}
	/>
);

function App() {
	const isLoggedIn = checkUser();

	return (
		<>
			<Toaster
				position="top-right"
				toastOptions={{
					className: 'glass-card text-text-heading',
					style: {
						background: '#FDFDFF',
						color: '#334155',
						backdropFilter: 'blur(10px)',
						border: '1px solid #e2e8f0',
					},
				}}
			/>
			<Router>
				<Sidebar checkUser={isLoggedIn} />
				<ScrollToTop />
				<div className={isLoggedIn ? `md:ml-64` : ``}>
					<Switch>
						<Route exact path="/" component={Login} />
						<PrivateRoute exact path="/dashboard" component={Dashboard} />
						<PrivateRoute exact path="/user" component={User} />
						<PrivateRoute exact path="/rapor" component={Rapor} />
						<PrivateRoute exact path="/kegiatan" component={Kegiatan} />
						<PrivateRoute
							exact
							path="/detailRapor/:turn/:nim"
							component={DetailRapor}
						/>
						<PrivateRoute exact path="/aspek" component={Aspek} />
						<PrivateRoute exact path="/bestStaff" component={BestStaff} />
						<Redirect from="*" to="/" />
					</Switch>
					{isLoggedIn && <Footer />}
				</div>
			</Router>
		</>
	);
}

export default App;
